import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast } from "../../../utils/toasts";
import { useProgramContext } from "../../../components/custom/programs/ProgramContext";
import { type ProgramFormValues, toProgramFields } from "../programFormValues";

interface Options {
  id: number;
  templateType: string;
  onSuccess?: () => void;
}

export const useUpdateProgram = ({ id, templateType, onSuccess }: Options) => {
  const { t } = useTranslation(["programs"]);
  const { engine } = useProgramContext();

  return useMutation({
    mutationFn: async (values: ProgramFormValues) =>
      await apiClient.updateProgram(
        { ...toProgramFields(values, templateType), engine, status: "scheduled" },
        { params: { id } },
      ),
    onSuccess: () => onSuccess?.(),
    onError: (error) => {
      errorToast({ message: t(($) => $.programs["Failed to save the program"]), error });
    },
  });
};
